import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
export class TaxSummaryModel {
  constructor(taxSummaryModel) {
    _defineProperty(this, "totalExempt", void 0);
    this.totalExempt = taxSummaryModel.totalExempt;
  }
  static fromV1(_ref) {
    let {
      taxSummary,
      modelContext
    } = _ref;
    return new TaxSummaryModel({
      totalExempt: PriceModel.fromV1(taxSummary == null ? void 0 : taxSummary.totalExempt, modelContext)
    });
  }
}
//# sourceMappingURL=TaxSummary.model.js.map